import { CommonModule } from '@angular/common';
import { Component, Output, EventEmitter } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-customer-input',
  imports: [
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule
  ],
  templateUrl: './customer-input.component.html'
})
export class CustomerInputComponent {
  @Output() customerDataChange = new EventEmitter<{name: string, document: string}>();
  @Output() customerConfirmed = new EventEmitter<{name: string, document: string}>();

  customerName: string = '';
  customerDocument: string = '';

  onNameChange(): void {
    this.emitData();
  }

  onDocumentChange(): void {
    this.emitData();
  }

  onNameKeyup(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      // Se o nome estiver preenchido, focar no campo de documento
      if (this.customerName.trim()) {
        const documentInput = document.getElementById('customer-document-input');
        if (documentInput) {
          documentInput.focus();
        }
      }
    }
  }

  onDocumentKeyup(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.confirmCustomer();
    }
  }

  confirmCustomer(): void {
    // Validar se pelo menos um campo foi preenchido
    if (this.customerName.trim() || this.customerDocument.trim()) {
      this.emitData();
      this.customerConfirmed.emit({
        name: this.customerName,
        document: this.customerDocument
      });
    }
  }

  private emitData(): void {
    this.customerDataChange.emit({
      name: this.customerName,
      document: this.customerDocument
    });
  }

  clear(): void {
    this.customerName = '';
    this.customerDocument = '';
    this.emitData();
  }
}

